import React, { useEffect, useState } from "react";
import { Table, Tooltip } from "antd";
import ReactPaginate from "react-js-pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FaEye } from "react-icons/fa";
import { MdAutoDelete, MdDelete, MdEdit } from "react-icons/md";

import { BsPinAngleFill } from "react-icons/bs";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import ModalPopup from "../../Common/Modal/Modal";
import {
  GetCredentialsData,
  DeleteCredential,
  UpdateCredentialFavorite,
  DeleteSensCredential,
  ToggleSensCredential,
  ToggleCredential,
  SendCredentialSecretKey,
  ValidateCredentialSecretKey,
} from "../../../Api/SuperAdminVault/Credentials";
import SecretAccessModal from "./SecretAccessModal";
import { IoMdShareAlt } from "react-icons/io";
import ShareModal from "../ShareModal";
import { FaLock, FaLockOpen } from "react-icons/fa6";
import {
  encryptVaultSecret,
  decryptVaultSecret,
} from "../../Common/Encrypt-Decrypt";
import CredentialsOtpModal from "./CredentialsOtpModal";

const Credentials = ({
  searchValue = "",
  typeFilter = "",
  refreshKey = 0,
  openCredentialModal,
  otpPurpose,
  setOtpPurpose,
  verified,
  setVerified,
}) => {
  const dispatch = useDispatch();

  const credentialList = useSelector(
    (state) => state.crm.credentials_list || []
  );

  const pageContext = useSelector(
    (state) => state.crm.credentials_page_context || {}
  );

  const [activePage, setActivePage] = useState(1);
  const [sortOrder, setSortOrder] = useState("D");
  const [sortColumn, setSortColumn] = useState("cred_id");

  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [selectedCredential, setSelectedCredential] = useState(null);
  const [selectedCredId, setSelectedCredId] = useState(null);

  const [secretModalOpen, setSecretModalOpen] = useState(false);
  const [shareModalIsOpen, setShareModalIsOpen] = useState(false);

  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otpAction, setOtpAction] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);

  const [toggleStatus, setToggleStatus] = useState(null);

  const itemsPerPage = 10;
  const totalItems = Number(pageContext?.total || 0);

  const isExpiredCredential = (row) => {
  return row?.expires_at && dayjs(row.expires_at).isBefore(dayjs(), "day");
};

  const typeLabelMap = {
    api_key: "API Key",
    login: "Login",
    database: "Database",
    cloud: "Cloud",
    token: "Token",
  };

  const fetchCredentials = async (pageNo = activePage) => {
    await GetCredentialsData({
      dispatch,
      page: pageNo,
      limit: itemsPerPage,
      sort_order: sortOrder,
      sort_column: sortColumn,
      filter_category: typeFilter,
      search: searchValue,
    });
  };

  useEffect(() => {
    setActivePage(1);
    fetchCredentials(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, typeFilter, sortOrder, sortColumn, refreshKey]);

  const closeOtpModal = () => {
    setOtpModalOpen(false);
    setOtpAction("");
    setToggleStatus(null);
  };

  const mapCredentialForEdit = async (data) => {
    const decryptedSecret = data?.secret_encrypted
      ? await decryptVaultSecret(data.secret_encrypted)
      : "";

    window.__EDIT_CREDENTIAL_DATA__ = {
      credential_type: data?.credential_type || "",
      credential_name: data?.credential_name || "",
      provider_name: data?.provider_name || "",
      username: data?.username || "",
      secret: decryptedSecret || "",
      expires_at: data?.expires_at || "",
      notes: data?.notes || "",
      is_sensitive: data?.is_sensitive ?? false,
    };
  };

  const handleViewSecret = (row) => {
    setSelectedCredential(row);
    setSelectedCredId(row?.cred_id);
    setOtpPurpose("view_credentials");
    setSecretModalOpen(true);
  };

  const handleEditClick = async (row) => {
    setSelectedCredential(row);
    setSelectedCredId(row?.cred_id);

    const response = await SendCredentialSecretKey(
      row?.cred_id,
      "update_credentials"
    );

    if (response?.data?.[0]) {
      await mapCredentialForEdit(response.data[0]);
      openCredentialModal("edit", row?.cred_id);
      return;
    }

    if (response?.success && response?.message) {
      setOtpAction("view_for_update");
      setOtpModalOpen(true);
    }
  };

  const handleDeleteClick = async (row) => {
    setSelectedCredential(row);
    setSelectedCredId(row?.cred_id);

    if (row?.is_sensitive === true) {
      const response = await DeleteCredential(row?.cred_id, dispatch, {
        page: activePage,
        limit: itemsPerPage,
        sort_order: sortOrder,
        sort_column: sortColumn,
        filter_category: typeFilter,
        search: searchValue,
      });

      if (response?.success || response?.message) {
        setOtpAction("delete");
        setOtpModalOpen(true);
      }

      return;
    }

    setDeleteModalIsOpen(true);
  };

  const handleToggleSensitive = async (row, status) => {
    setSelectedCredential(row);
    setSelectedCredId(row?.cred_id);
    setToggleStatus(status);

    if (row?.is_sensitive === true) {
      await ToggleCredential(row?.cred_id, status);
      setOtpAction("sensitive_toggle");
      setOtpModalOpen(true);
      return;
    }

    await ToggleCredential(row?.cred_id, status);
    fetchCredentials(activePage);
  };

  const handleOtpVerify = async (plainOtp) => {
    if (!selectedCredential?.cred_id) return;

    try {
      setOtpLoading(true);

      const encryptedOtp = await encryptVaultSecret(plainOtp);
      console.log(decryptVaultSecret(encryptedOtp),"jjjjjj");
      

      if (otpAction === "view_for_update") {
        const response = await ValidateCredentialSecretKey({
          cred_id: String(selectedCredential.cred_id),
          otp: encryptedOtp,
          otp_purpose: "update_credentials",
        });

        if (response?.data?.[0]) {
          await mapCredentialForEdit(response.data[0]);
          closeOtpModal();
          openCredentialModal("edit", selectedCredential.cred_id);
        }

        return;
      }

      if (otpAction === "delete") {
        const nextPage =
          credentialList.length === 1 && activePage > 1
            ? activePage - 1
            : activePage;

        await DeleteSensCredential(
          selectedCredential.cred_id,
          dispatch,
          {
            page: nextPage,
            limit: itemsPerPage,
            sort_order: sortOrder,
            sort_column: sortColumn,
            filter_category: typeFilter,
            search: searchValue,
          },
          encryptedOtp
        );

        setActivePage(nextPage);
        closeOtpModal();
        setSelectedCredential(null);
        setSelectedCredId(null);

        return;
      }

      if (otpAction === "sensitive_toggle") {
        await ToggleSensCredential(
          selectedCredential.cred_id,
          toggleStatus,
          encryptedOtp
        );

        await fetchCredentials(activePage);
        closeOtpModal();

        return;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setOtpLoading(false);
    }
  };

  const handleOtpResend = async () => {
    if (!selectedCredential?.cred_id) return;

    if (otpAction === "view_for_update") {
      await SendCredentialSecretKey(
        selectedCredential.cred_id,
        "update_credentials"
      );
    }

    if (otpAction === "delete") {
      await DeleteCredential(selectedCredential.cred_id, dispatch, {
        page: activePage,
        limit: itemsPerPage,
        sort_order: sortOrder,
        sort_column: sortColumn,
        filter_category: typeFilter,
        search: searchValue,
      });
    }

    if (otpAction === "sensitive_toggle") {
      await ToggleCredential(selectedCredential.cred_id, toggleStatus);
    }
  };

  const handleDeleteCredential = async (credential = selectedCredential) => {
    if (!credential?.cred_id) return;

    const nextPage =
      credentialList.length === 1 && activePage > 1
        ? activePage - 1
        : activePage;

    await DeleteCredential(credential.cred_id, dispatch, {
      page: nextPage,
      limit: itemsPerPage,
      sort_order: sortOrder,
      sort_column: sortColumn,
      filter_category: typeFilter,
      search: searchValue,
    });

    setActivePage(nextPage);
    closeDeleteModal();
  };

  const handleToggleFavorite = async (row) => {
  await UpdateCredentialFavorite(
  row?.cred_id,
  !row?.is_favorite
);
    fetchCredentials(activePage);
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setSelectedCredential(null);
  };

  const handlePageChange = async (pageNumber) => {
    setActivePage(pageNumber);

    await GetCredentialsData({
      dispatch,
      page: pageNumber,
      limit: itemsPerPage,
      sort_order: sortOrder,
      sort_column: sortColumn,
      filter_category: typeFilter,
      search: searchValue,
    });
  };

  const handleSort = (column) => {
    setActivePage(1);

    if (sortColumn !== column) {
      setSortColumn(column);
      setSortOrder("A");
      return;
    }

    if (sortOrder === "A") {
      setSortOrder("D");
      return;
    }

    setSortColumn("cred_id");
    setSortOrder("D");
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return dayjs(date).format("DD MMM, YY");
  };

  const renderSortIcon = (column) => {
    if (sortColumn !== column) {
      return (
        <Tooltip
          placement="top"
          title="Unsorted"
          overlayStyle={{ pointerEvents: "none" }}
          color="white"
          overlayInnerStyle={{ color: "#1F487C" }}
        >
          <TiArrowUnsorted />
        </Tooltip>
      );
    }

    if (sortOrder === "A") {
      return (
        <Tooltip
          placement="top"
          title="Ascending"
          overlayStyle={{ pointerEvents: "none" }}
          color="white"
          overlayInnerStyle={{ color: "#1F487C" }}
        >
          <TiArrowSortedUp />
        </Tooltip>
      );
    }

    return (
      <Tooltip
        placement="top"
        title="Descending"
        overlayStyle={{ pointerEvents: "none" }}
        color="white"
        overlayInnerStyle={{ color: "#1F487C" }}
      >
        <TiArrowSortedDown />
      </Tooltip>
    );
  };

  const SortHeader = ({ title, column }) => (
    <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
      {title}
      <button onClick={() => handleSort(column)}>
        {renderSortIcon(column)}
      </button>
    </h1>
  );

  const columns = [
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          S.No
        </h1>
      ),
      width: "4vw",
      render: (row, rowdta, index) => {
        const serialNumber = (activePage - 1) * itemsPerPage + (index + 1);

        return (
          <h1 className="flex justify-center font-bold items-center text-[1vw] text-[#1F487C]">
            {serialNumber}
          </h1>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Name
        </h1>
      ),
      width: "18vw",
      render: (row) => (
        <div className="flex items-center justify-center">
          {row?.credential_name?.length > 18 ? (
            <Tooltip
              placement="top"
              title={row?.credential_name}
              className="cursor-pointer text-[#1F487C]"
              color="white"
              overlayInnerStyle={{ color: "#1F487C" }}
            >
              <p className="text-[1vw] font-bold text-[#1F487C]">
                {`${row?.credential_name?.slice(0, 18)}...`}
              </p>
            </Tooltip>
          ) : (
            <h1 className="text-[1vw] font-bold text-[#1F487C]">
              {row?.credential_name || "-"}
            </h1>
          )}
        </div>
      ),
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Type
        </h1>
      ),
      width: "12vw",
      render: (row) => {
        const typeName =
          typeLabelMap[row?.credential_type] || row?.credential_type || "-";

        return (
          <div className="flex items-center justify-center">
            <p className="text-[1vw] font-bold text-[#1F487C]">{typeName}</p>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Owner
        </h1>
      ),
      width: "15vw",
      render: (row) => (
        <div className="flex items-center justify-center">
          {row?.provider_name?.length > 15 ? (
            <Tooltip
              placement="top"
              title={row?.provider_name}
              className="cursor-pointer text-[#1F487C]"
              color="white"
              overlayInnerStyle={{ color: "#1F487C" }}
            >
              <p className="text-[1vw] font-bold text-[#1F487C]">
                {`${row?.provider_name?.slice(0, 15)}...`}
              </p>
            </Tooltip>
          ) : (
            <p className="text-[1vw] font-bold text-[#1F487C]">
              {row?.provider_name || "-"}
            </p>
          )}
        </div>
      ),
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Username
        </h1>
      ),
      width: "20vw",
      render: (row) => (
        <div className="flex items-center justify-center">
          {row?.username?.length > 22 ? (
            <Tooltip
              placement="top"
              title={row?.username}
              className="cursor-pointer text-[#1F487C]"
              color="white"
              overlayInnerStyle={{ color: "#1F487C" }}
            >
              <p className="text-[1vw] font-bold text-[#1F487C]">
                {`${row?.username?.slice(0, 22)}...`}
              </p>
            </Tooltip>
          ) : (
            <p className="text-[1vw] font-bold text-[#1F487C]">
              {row?.username || "-"}
            </p>
          )}
        </div>
      ),
    },
    {
      title: <SortHeader title="Updated" column="updated_at" />,
      width: "12vw",
      render: (row) => (
        <div className="flex items-center justify-center">
          <p className="text-[1vw] text-[#1F487C]">
            {formatDate(row?.updated_at)}
          </p>
        </div>
      ),
    },
   {
  title: <SortHeader title="Expires" column="expires_at" />,
  width: "12vw",
  render: (row) => {
    const expired = isExpiredCredential(row);

    return (
      <p
        className={`text-[1vw] flex items-center justify-center ${
          expired ? "text-[#FD3434] font-bold" : "text-[#1F487C]"
        }`}
      >
        {expired
          ? "Expired"
          : row?.expires_at
            ? dayjs(row.expires_at).format("DD MMM, YY")
            : "-"}
      </p>
    );
  },
},
    {
      title: (
        <h1 className="text-[1.1vw] font-bold text-center flex items-center justify-center">
          Actions
        </h1>
      ),
      width: "17vw",
      render: (row) => (
        <div className="grid grid-cols-6 gap-[0.35vw] items-center justify-center px-[1vw]">
          <FaEye
            size="1.3vw"
            color="#1F4B7F"
            className="cursor-pointer"
            onClick={() => handleViewSecret(row)}
          />

          <MdEdit
            size="1.3vw"
            color="#1F4B7F"
            className="cursor-pointer"
            onClick={() => handleEditClick(row)}
          />

          <MdDelete
            size="1.3vw"
            color="#1F4B7F"
            className="cursor-pointer"
            onClick={() => handleDeleteClick(row)}
          />

          <BsPinAngleFill
            size="1.3vw"
            color={row?.is_favorite ? "#1F4B7F" : "#989fab"}
            className="cursor-pointer"
            onClick={() => handleToggleFavorite(row)}
          />

          <Tooltip
            title={row?.is_sensitive ? "Unlock" : "Lock"}
            color="white"
            overlayInnerStyle={{ color: "#1F487C" }}
          >
            {row?.is_sensitive ? (
              <FaLock
                size="1.1vw"
                color="#1F4B7F"
                className="cursor-pointer"
                onClick={() => handleToggleSensitive(row, "false")}
              />
            ) : (
              <FaLockOpen
                size="1.1vw"
                color="#9CA3AF"
                className="cursor-pointer"
                onClick={() => handleToggleSensitive(row, "true")}
              />
            )}
          </Tooltip>

          <IoMdShareAlt
            size="1.3vw"
            color="#1F4B7F"
            className="cursor-pointer"
            onClick={() => {
              setShareModalIsOpen(true);
              setSelectedCredential(row);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="h-[72vh] w-full">
        <Table
          dataSource={credentialList}
          columns={columns}
          pagination={false}
          className="custom-table"
          rowKey={(row) => row?.cred_id}
        />
      </div>

      {totalItems > itemsPerPage && (
        <div className="w-full h-[8vh] flex justify-between items-center">
          <div className="text-[#1F4B7F] flex text-[1.1vw] gap-[0.5vw]">
            <span>Showing</span>
            <span className="font-bold">
              {(activePage - 1) * itemsPerPage + 1} -{" "}
              {Math.min(activePage * itemsPerPage, totalItems)}
            </span>
            <span>from</span>
            <span className="font-bold">{totalItems}</span>
            <span>data</span>
          </div>

          <ReactPaginate
            activePage={activePage}
            itemsCountPerPage={itemsPerPage}
            totalItemsCount={totalItems}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            activeClass="active"
            prevPageText={<FontAwesomeIcon icon={faChevronLeft} size="1vw" />}
            nextPageText={<FontAwesomeIcon icon={faChevronRight} size="1vw" />}
            firstPageText={
              <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
            }
            lastPageText={
              <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
            }
          />
        </div>
      )}

      <SecretAccessModal
        show={secretModalOpen}
        credId={selectedCredId}
        otpPurpose={otpPurpose}
        mode="view"
        onClose={() => {
          setSecretModalOpen(false);
          setSelectedCredId(null);
        }}
        verified={verified}
        setVerified={setVerified}
      />

      <ShareModal
        show={shareModalIsOpen}
        onClose={() => {
          setShareModalIsOpen(false);
          setSelectedCredId(null);
        }}
        previewContent={
          <div>
            <div className="flex gap-1">
              <p className="font-semibold">Credential name:</p>
              <p>{selectedCredential ? selectedCredential?.credential_name : "-"}</p>
            </div>
            <div className="flex gap-1">
              <p className="font-semibold">Credential type:</p>
              <p>{selectedCredential ? selectedCredential?.credential_type : "-"}</p>
            </div>
            <div className="flex gap-1">
              <p className="font-semibold">Username / Email:</p>
              <p>{selectedCredential ? selectedCredential?.username : "-"}</p>
            </div>
            <div className="flex gap-1">
              <p className="font-semibold">Password:</p>
              <p>
                {selectedCredential ? selectedCredential?.secret_last_four : "-"}
              </p>
              
            </div>
            <p>( ⚠ The recipient will receive the complete password in plain text. )</p>
          </div>
        }
        module="credentials"
        id={selectedCredential?.cred_id}
        isSens={selectedCredential?.is_sensitive}
      />

      <ModalPopup
        show={deleteModalIsOpen}
        onClose={closeDeleteModal}
        height="20vw"
        width="30vw"
        closeicon={false}
      >
        <div className="flex flex-col justify-center">
          <div className="items-center flex-col flex justify-center mt-[0.5vw]">
            <MdAutoDelete color="#1f4b7f" size="5vw" />

            <p className="text-[1.7vw] font-semibold text-[#1f4b7f] mt-[1vw]">
              Are You Sure ?
            </p>

            <p className="flex justify-center items-center gap-[0.5vw] text-[1.1vw] text-[#1f4b7f] mt-[0.5vw] text-center leading-tight">
              <span>Want to delete this</span>
              <span>{selectedCredential?.credential_name || "-"}</span>
              <span>?</span>
            </p>
          </div>

          <div className="flex items-center mt-[2vw] gap-[2vw] justify-center">
            <button
              className="border-[#1f4b7f] border-[0.1vw] rounded-[0.5vw] text-[1.1vw] font-semibold text-[#1f4b7f] w-[10vw] h-[3vw]"
              onClick={closeDeleteModal}
            >
              No
            </button>

            <button
              className="bg-[#1f4b7f] text-white font-semibold text-[1.1vw] w-[10vw] h-[3vw] rounded-[0.5vw]"
              onClick={() => handleDeleteCredential()}
            >
              Yes
            </button>
          </div>
        </div>
      </ModalPopup>

      <CredentialsOtpModal
        show={otpModalOpen}
        actionType={otpAction}
        loading={otpLoading}
        onClose={closeOtpModal}
        onVerify={handleOtpVerify}
        onResend={handleOtpResend}
      />
    </>
  );
};

export default Credentials;